import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import Contractor from '../../components/people/contractor/Contractor'
import { getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import Pagination from '../../components/pagination/Pagination'
import SinglePage from '../../components/pagination/SinglePage'

import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'
import TravelStep2 from './TravelStep2'

import { isEmpty } from '../../libs/validation/stringRegex'
import { isNotValidDataFineViaggio, isNotValidDataInzioViaggio } from '../../libs/validation/dateValidation'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'


import {
    getTipoCopertura,    getTipoDestinazione,    getTipoDurata,
    getTipoNumero_figli,    getTipoPersona,    getTipoViaggio,
} from '../../libs/initialization/remoteInits'

import { TravelPageProps, TravelPageState, travelPageInitialState, travelUpdate } from './TravelPageSilce'
import * as TravelValidation from './TravelValidation'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class TravelPage extends BasePage<TravelPageProps, TravelPageState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...travelPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateTipo_viaggio = this.updateTipo_viaggio.bind(this)
        this.updateDestinazione = this.updateDestinazione.bind(this)
        this.updateData_inizio = this.updateData_inizio.bind(this)
        this.updateData_fine = this.updateData_fine.bind(this)
        this.updateDurata = this.updateDurata.bind(this)
        this.updateSoggetti = this.updateSoggetti.bind(this)
        this.updateEta = this.updateEta.bind(this)
        this.updateEta_assicurato_1 = this.updateEta_assicurato_1.bind(this)
        this.updateEta_assicurato_2 = this.updateEta_assicurato_2.bind(this)
        this.updateNumero_figli = this.updateNumero_figli.bind(this)
        this.updateNumero_partecipanti = this.updateNumero_partecipanti.bind(this)
        this.updateEta_partecipanti = this.updateEta_partecipanti.bind(this)
        this.updateTipo_copertura = this.updateTipo_copertura.bind(this)

        this.updateTipoCopertura = this.updateTipoCopertura.bind(this)
        this.updateTipoDestinazione = this.updateTipoDestinazione.bind(this)
        this.updateTipoDurata = this.updateTipoDurata.bind(this)
        this.updateTipoNumero_figli = this.updateTipoNumero_figli.bind(this)
        this.updateTipoPersona = this.updateTipoPersona.bind(this)
        this.updateTipoViaggio = this.updateTipoViaggio.bind(this)

        this.stepTwoValidation = this.stepTwoValidation.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipo_coperture === undefined) {
            getTipoCopertura (this.updateTipoCopertura, this.manageExpiredSessions)
        }
        if (this.state.tipo_destinazioni === undefined) {
            getTipoDestinazione (this.updateTipoDestinazione, this.manageExpiredSessions)
        }
        if (this.state.tipo_durate === undefined) {
            getTipoDurata (this.updateTipoDurata, this.manageExpiredSessions)
        }
        if (this.state.tipo_numero_figli === undefined) {
            getTipoNumero_figli (this.updateTipoNumero_figli, this.manageExpiredSessions)
        }
        if (this.state.tipo_persone === undefined) {
            getTipoPersona (this.updateTipoPersona, this.manageExpiredSessions)
        }
        if (this.state.tipo_viaggi === undefined) {
            getTipoViaggio (this.updateTipoViaggio, this.manageExpiredSessions)
        }
        
    }

    componentDidUpdate(prevProps: Readonly<TravelPageProps>, prevState: Readonly<TravelPageState>, snapshot?: any): void {
        super.componentDidUpdate (prevProps, prevState, snapshot)
        
        let obj = {}

        if (prevState.tipo_viaggio === 'polizzaAnnuale' && this.state.tipo_viaggio !== 'polizzaAnnuale') {
            obj = {
                ...obj,
                ...{durata: undefined}
            }
        }
        else if (prevState.tipo_viaggio === 'viaggioSingolo' && this.state.tipo_viaggio !== 'viaggioSingolo') {
            obj = {
                ...obj,
                ...{
                    data_inizio: undefined,
                    data_fine: undefined
                }
            }
        }

        if (prevState.soggetti === 'singolaPersona' && this.state.soggetti !== 'singolaPersona') {
            obj = {
                ...obj,
                ...{eta: undefined}
            }
        }
        else if (prevState.soggetti === 'coppia' && this.state.soggetti !== 'coppia') {
            obj = {
                ...obj,
                ...{
                    eta_assicurato_1: undefined,
                    eta_assicurato_2: undefined,
                }
            }
        }
        else if (prevState.soggetti === 'famiglia' && this.state.soggetti !== 'famiglia') {
            obj = {
                ...obj,
                ...{eta_partecipanti: undefined}
            }
        }
        
        if (
            (prevState.soggetti === 'famiglia' && this.state.soggetti !== 'famiglia') ||
            (prevState.soggetti === 'genitoreConFigli' && this.state.soggetti !== 'genitoreConFigli')
        ) {
            obj = {
                ...obj,
                ...{numero_figli: undefined}
            }
        }

        if (Object.keys(obj).length > 0) {
            this.saveStateAndRedux( obj )
        }
    }

    render (): ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="travel_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.stepTwoValidation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <TravelStep2 
                                            tipo_viaggio = {this.state.tipo_viaggio}
                                            destinazione = {this.state.destinazione}
                                            data_inizio = {this.state.data_inizio}
                                            data_fine = {this.state.data_fine}
                                            durata = {this.state.durata}
                                            soggetti = {this.state.soggetti}
                                            eta = {this.state.eta}
                                            eta_assicurato_1 = {this.state.eta_assicurato_1}
                                            eta_assicurato_2 = {this.state.eta_assicurato_2}
                                            numero_figli = {this.state.numero_figli}
                                            numero_partecipanti = {this.state.numero_partecipanti}
                                            eta_partecipanti = {this.state.eta_partecipanti}
                                            tipo_copertura = {this.state.tipo_copertura}
                                            user = {this.state.user}
                                            noMotorPrivacy = {this.state.noMotorPrivacy}

                                            tipo_viaggioError = {this.state.tipo_viaggioError}
                                            destinazioneError = {this.state.destinazioneError}
                                            data_inizioError = {this.state.data_inizioError}
                                            data_fineError = {this.state.data_fineError}
                                            durataError = {this.state.durataError}
                                            soggettiError = {this.state.soggettiError}
                                            etaError = {this.state.etaError}
                                            eta_assicurato_1Error = {this.state.eta_assicurato_1Error}
                                            eta_assicurato_2Error = {this.state.eta_assicurato_2Error}
                                            numero_figliError = {this.state.numero_figliError}
                                            numero_partecipantiError = {this.state.numero_partecipantiError}
                                            eta_partecipantiError = {this.state.eta_partecipantiError}
                                            tipo_coperturaError = {this.state.tipo_coperturaError}
                                            noMotorPrivacyError = {this.state.noMotorPrivacyError}

                                            tipo_coperture = {this.state.tipo_coperture}
                                            tipo_destinazioni = {this.state.tipo_destinazioni}
                                            tipo_durate = {this.state.tipo_durate}
                                            tipo_numero_figli = {this.state.tipo_numero_figli}
                                            tipo_persone = {this.state.tipo_persone}
                                            tipo_viaggi = {this.state.tipo_viaggi}

                                            updateTipo_viaggioCallBack = {this.updateTipo_viaggio}
                                            updateDestinazioneCallBack = {this.updateDestinazione}
                                            updateData_inizioCallBack = {this.updateData_inizio}
                                            updateData_fineCallBack = {this.updateData_fine}
                                            updateDurataCallBack = {this.updateDurata}
                                            updateSoggettiCallBack = {this.updateSoggetti}
                                            updateEtaCallBack = {this.updateEta}
                                            updateEta_assicurato_1CallBack = {this.updateEta_assicurato_1}
                                            updateEta_assicurato_2CallBack = {this.updateEta_assicurato_2}
                                            updateNumero_figliCallBack = {this.updateNumero_figli}
                                            updateNumero_partecipantiCallBack = {this.updateNumero_partecipanti}
                                            updateEta_partecipantiCallBack = {this.updateEta_partecipanti}
                                            updateTipo_coperturaCallBack = {this.updateTipo_copertura}
                                            updateNoMotorPrivacyCallBack = {this.updateNoMotorPrivacy}
                                        />
                                    </SinglePage>
                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return travelPageInitialState
    }
    
    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.stepTwoValidation(),
        ]).then ((responses) => {

            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }
            
            return {
                errorString: e,
                pageError: p
            }

        }).catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } 
        else {
            let tipo_viaggioErro = undefined
            let destinazioneErro = undefined
            let data_inizioErro = undefined
            let data_fineErro = undefined
            let durataErro = undefined
            let soggettiErro = undefined
            let etaErro = undefined
            let eta_assicurato_1Erro = undefined
            let eta_assicurato_2Erro = undefined
            let numero_figliErro = undefined
            let numero_partecipantiErro = undefined
            let eta_partecipantiErro = undefined
            let tipo_coperturaErro = undefined

            let noMotorPrivacyErro = undefined
            let global = undefined
            
            if (errorString === 'TIPO_VIAGGIO') {
                tipo_viaggioErro = 'Valore non valido'
                global = 'Selezionare la tipologia di viaggio'
            }
            else if (errorString === 'DESTINAZIONE') {
                destinazioneErro = 'Valore non valido'
                global = 'Selezionare la destinazione'
            }
            else if (errorString === 'DATA_INIZIO') {
                data_inizioErro = 'Valore non valido'
                global = 'Selezionare la data inizio'
            }
            else if (errorString === 'DATA_FINE') {
                data_fineErro = 'Valore non valido'
                global = 'Selezionare la data fine'
            }
            else if (errorString === 'DURATA') {
                durataErro = 'Valore non valido'
                global = 'Selezionare durata durata'
            }
            else if (errorString === 'SOGGETTI') {
                soggettiErro = 'Valore non valido'
                global = 'Selezionare i soggetti partecipanti'
            }
            else if (errorString === 'ETA') {
                etaErro = 'Valore non valido'
                global = "Indicare l'età"
            }
            else if (errorString === 'ETA_ASSICURATO_1') {
                eta_assicurato_1Erro = 'Valore non valido'
                global = "Indicare l'età del assicurato 1"
            }
            else if (errorString === 'ETA_ASSICURATO_2') {
                eta_assicurato_2Erro = 'Valore non valido'
                global = "Indicare l'età del assicurato 2"
            }
            else if (errorString === 'NUMERO_FIGLI') {
                numero_figliErro = 'Valore non valido'
                global = 'Selezionare il numero di figli'
            }
            else if (errorString === 'NUMERO_PARTECIPANTI') {
                numero_partecipantiErro = 'Valore non valido'
                global = 'Indicare il numero di partecipanti'
            }
            else if (errorString === 'ETA_PARTECIPANTI') {
                eta_partecipantiErro = 'Valore non valido'
                global = "Indicare l'età partecipanti"
            }
            else if (errorString === 'TIPO_COPERTURA') {
                tipo_coperturaErro = 'Valore non valido'
                global = 'Selezionare il tipo di copertura'
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            } 
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                tipo_viaggioError: tipo_viaggioErro,
                destinazioneError: destinazioneErro,
                data_inizioError: data_inizioErro,
                data_fineError: data_fineErro,
                durataError: durataErro,
                soggettiError: soggettiErro,
                etaError: etaErro,
                eta_assicurato_1Error: eta_assicurato_1Erro,
                eta_assicurato_2Error: eta_assicurato_2Erro,
                numero_figliError: numero_figliErro,
                numero_partecipantiError: numero_partecipantiErro,
                eta_partecipantiError: eta_partecipantiErro,
                tipo_coperturaError: tipo_coperturaErro,
                
                noMotorPrivacyError: noMotorPrivacyErro,
                globalError: global,
            })
        }
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            tipo_viaggio: (this.state.tipo_viaggio !== undefined) ? this.state.tipo_viaggio : null,
            destinazione: (this.state.destinazione !== undefined) ? this.state.destinazione : null,
            data_inizio: (this.state.data_inizio !== undefined) ? this.state.data_inizio : null,
            data_fine: (this.state.data_fine !== undefined) ? this.state.data_fine : null,
            durata: (this.state.durata !== undefined) ? this.state.durata : null,
            soggetti: (this.state.soggetti !== undefined) ? this.state.soggetti : null,
            eta: (this.state.eta !== undefined) ? this.state.eta : null,
            eta_assicurato_1: (this.state.eta_assicurato_1 !== undefined) ? this.state.eta_assicurato_1 : null,
            eta_assicurato_2: (this.state.eta_assicurato_2 !== undefined) ? this.state.eta_assicurato_2 : null,
            numero_figli: (this.state.numero_figli !== undefined) ? this.state.numero_figli : null,
            numero_partecipanti: (this.state.numero_partecipanti !== undefined) ? this.state.numero_partecipanti : null,
            eta_partecipanti: (this.state.eta_partecipanti !== undefined) ? this.state.eta_partecipanti : null,
            tipo_copertura: (this.state.tipo_copertura !== undefined) ? this.state.tipo_copertura : null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, 
            () => {
                store.dispatch (
                    travelUpdate (this.state)
                )
            }
        )
    }

    // specifici
    private stepTwoValidation () {
        let global = TravelValidation.stepTwoValidation (
            this.state.altriSinistri,
            this.state.polizzaAttiva,
            this.state.scadenzaPolizza,
            this.state.tipo_viaggio,
            this.state.destinazione,
            this.state.data_inizio,
            this.state.data_fine,
            this.state.durata,
            this.state.soggetti,
            this.state.eta,
            this.state.eta_assicurato_1,
            this.state.eta_assicurato_2,
            this.state.numero_figli,
            this.state.numero_partecipanti,
            this.state.eta_partecipanti,
            this.state.tipo_copertura,

            this.state.user,
            getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),

            this.printError,
            this.manageExpiredSessions
        )

        return global
    }

    private updateTipo_viaggio (val: string | undefined) {
        let obj = {
            tipo_viaggio: val,
            tipo_viaggioError: undefined
        }
        if (val !== 'polizzaAnnuale') {
            obj = {
                ...obj,
                ...{
                    durata: undefined
                }
            }
        }
        if (val !== 'viaggioSingolo') {
            obj = {
                ...obj,
                ...{
                    data_inizio: undefined,
                    data_fine: undefined
                }
            }
        }

        this.saveStateAndRedux( obj )
    }
    private updateDestinazione (val: string | undefined) {
        this.saveStateAndRedux({
            destinazione: val,
            destinazioneError: undefined
        })
    }
    private updateData_inizio (val: string | undefined) {
        let next = {
            data_inizio: val,
            data_inizioError: undefined
        }

        if (
            this.state.data_fine !== undefined &&
            !isNotValidDataFineViaggio( val, this.state.data_fine )
        ) {
            next = {
                ...next,
                ...{
                    data_fineError: undefined
                }
            }
        }

        this.saveStateAndRedux(next)
    }
    private updateData_fine (val: string | undefined) {
        let next = {
            data_fine: val,
            data_fineError: undefined
        }

        if (
            this.state.data_inizio !== undefined &&
            !isNotValidDataInzioViaggio( this.state.data_inizio, val )
        ) {
            next = {
                ...next,
                ...{
                    data_inizioError: undefined
                }
            }
        }

        this.saveStateAndRedux( next )
    }
    private updateDurata (val: string | undefined) {
        this.saveStateAndRedux({
            durata: val,
            durataError: undefined
        })
    }
    private updateSoggetti (val: string | undefined) {
        let obj = {
            soggetti: val,
            soggettiError: undefined
        }
        if (val !== 'singolaPersona') {
            obj = {
                ...obj,
                ...{
                    eta: undefined
                }
            }
        }
        if (val !== 'coppia') {
            obj = {
                ...obj,
                ...{
                    eta_assicurato_1: undefined,
                    eta_assicurato_2: undefined,
                }
            }
        }
        if (val !== 'famiglia') {
            obj = {
                ...obj,
                ...{
                    eta_partecipanti: undefined,
                }
            }
        }
        if (val !== 'genitoreConFigli' && val !== 'famiglia') {
            obj = {
                ...obj,
                ...{
                    numero_figli: undefined,
                }
            }
        }
        if (val !== 'gruppo') {
            obj = {
                ...obj,
                ...{
                    numero_partecipanti: undefined,
                }
            }
        }

        this.saveStateAndRedux( obj )
    }
    private updateEta (val: number | undefined) {
        this.saveStateAndRedux({
            eta: val,
            etaError: undefined
        })
    }
    private updateEta_assicurato_1 (val: number | undefined) {
        this.saveStateAndRedux({
            eta_assicurato_1: val,
            eta_assicurato_1Error: undefined
        })
    }
    private updateEta_assicurato_2 (val: number | undefined) {
        this.saveStateAndRedux({
            eta_assicurato_2: val,
            eta_assicurato_2Error: undefined
        })
    }
    private updateNumero_figli (val: string | undefined) {
        this.saveStateAndRedux({
            numero_figli: val,
            numero_figliError: undefined
        })
    }
    private updateNumero_partecipanti (val: number | undefined) {
        let next = {
            numero_partecipanti: val,
            numero_partecipantiError: undefined
        }

        // numero "età partecipanti" deve essere <= numero_partecipanti
        if (this.state.eta_partecipanti !== undefined) {
            let etaPartecipnati = this.state.eta_partecipanti?.split( ';' )
            etaPartecipnati = etaPartecipnati.filter( x => !isEmpty(x))
            etaPartecipnati = etaPartecipnati.sort(this.compareEtaPartecipanti)

            if (val !== undefined && etaPartecipnati.length > val) {
                etaPartecipnati.length = val

                let tmp = ''

                etaPartecipnati.forEach( x => {
                    if (!isEmpty(x)) {
                        tmp += x +';'
                    }
                })

                next = {
                    ...next,
                    ...{eta_partecipanti: tmp}
                }
            }
        }
        
        this.saveStateAndRedux( next )
    }
    private compareEtaPartecipanti (a: string, b: string) {
        const ta = a.split(':')
        const tb = b.split(':')

        if (
            (ta === undefined || tb === undefined) ||
            Number(ta[0]) < Number(tb[0])
        ){ 
            return -1
        }
        if (Number(ta[0]) > Number(tb[0])) {
            return 1
        }
            
        return 0
    }

    private updateEta_partecipanti (val: string | undefined) {
        this.saveStateAndRedux({
            eta_partecipanti: val,
            eta_partecipantiError: undefined
        })
    }
    private updateTipo_copertura (val: string | undefined, add: boolean) {
        let next = this.state.tipo_copertura

        if ( val ) {
            if (add) {
                if (!next?.includes(val + '|')) {
                    next = (next ?? '') + val + '|'
                }
            }
            else {
                next = (next ?? '').replace( val + '|', '')
            }
        }

        this.saveStateAndRedux({
            tipo_copertura: next,
            tipo_coperturaError: undefined
        })
    }

    private updateTipoCopertura (val: any) {
        this.setState({
            tipo_coperture: val
        })
    }
    private updateTipoDestinazione (val: any) {
        this.setState({
            tipo_destinazioni: val
        })
    }
    private updateTipoDurata (val: any) {
        this.setState({
            tipo_durate: val
        })
    }
    private updateTipoNumero_figli (val: any) {
        this.setState({
            tipo_numero_figli: val
        })
    }
    private updateTipoPersona (val: any) {
        this.setState({
            tipo_persone: val
        })
    }
    private updateTipoViaggio (val: any) {
        this.setState({
            tipo_viaggi: val
        })
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    tipo_viaggio: state.tipo_viaggio,
    destinazione: state.destinazione,
    data_inizio: state.data_inizio,
    data_fine: state.data_fine,
    durata: state.durata,
    soggetti: state.soggetti,
    eta: state.eta,
    eta_assicurato_1: state.eta_assicurato_1,
    eta_assicurato_2: state.eta_assicurato_2,
    numero_figli: state.numero_figli,
    numero_partecipanti: state.numero_partecipanti,
    eta_partecipanti: state.eta_partecipanti,
    tipo_copertura: state.tipo_copertura,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (TravelPage)